<template lang="html">
  <section class="legals-layout take-place column">
		<div class="legals-master column">
			<div class="legals-title">
				Conditions Générales d'Utilisation
			</div>
			<div class="legals-body">
				<div class="item">Patrimoffice exerce en qualité de Conseil en Investissements Financiers (CIF).</div>
				<div class="item">La règlementation (article 325-3 du règlement général de l’AMF) prévoit pour les CIF l’obligation de remettre à son Client un Document d’Entrée en Relation (DER), avant la signature d’une lettre de mission.</div>
				<div class="item">Les informations communiquées dans ce DER sont des informations légales et réglementaires obligatoires qui permettent au Client d’avoir une vision du périmètre d’activités de la société, et des conditions d’exercice des différents métiers exercés par le gestionnaire de patrimoine.</div>
				<div class="item">Ce document est en accès libre sur notre site et peut être téléchargé <a href="https://www.patrimoffice.com/document-entree-en-relation/">ici</a>.</div>
			</div>
		</div>
  </section>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// CGU.vue?750aeb16